import React, { useState, useRef } from 'react';
import { Tabs, Card, message } from 'antd';
import { LocalPersistence } from '../../../factories';
import { addRecreation } from '../../../services/recreation';
import AddPage from './AddPageInfo';
import AddAccessibilityAndSecurity from './AccessibilityAndSecurity/AddAccessibilityAndSecurity';
import AddScheduleAndCharge from './ScheduleAndCharge/AddScheduleAndCharge';
import Loading from '../../Loading';
import PageContainer from '../../CSIComponents/PageContainer';
import ActionButtonsBar from '../../ui/ActionButtonsBar';

const { TabPane } = Tabs;
interface propsTypes {
  isEditable?: void | any;
  cancelEditable?: void | any;
  disableTabPanes?: void | any;
  detail?: any;
  cancelAndSave?: void | any;
}
const AddPageTab = (props: propsTypes) => {
  const [addLoading, setAddLoading] = useState(false);

  const AddDetailRef = useRef<any>();
  const AddScheduleAndChargeRef = useRef<any>();
  const AddAccessibilityAndSecurityRef = useRef<any>();
  const [transferDataAll, setTransferDataAll] = useState([]);
  const getTransferData = (data: any) => {
    setTransferDataAll(data);
  };

  const handlCancelClick = () => {
    props.cancelAndSave();
  };
  const addSave = async (value: any) => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();
    Promise.all([
      AddDetailRef.current.form.validateFields(),
      AddScheduleAndChargeRef.current.form.validateFields(),
      AddAccessibilityAndSecurityRef.current.form.validateFields(),
    ])
      .then(async (value) => {
        if (transferDataAll.length > 0) {
          value[0].tags = transferDataAll.join(' | ');
        }

        for (let key in value[1]) {
          if (value[1][key].description == undefined) {
            value[1][key].description = '';
          }
          if (
            value[1][key].startDatePicker &&
            value[1][key].startDatePicker.length > 0
          ) {
            value[1][key].startdate =
              value[1][key]?.startDatePicker[0]?.format('MM/DD/YYYY');
            value[1][key].enddate =
              value[1][key]?.startDatePicker[1]?.format('MM/DD/YYYY');
          } else if (value[1][key].startDatePicker == undefined) {
            value[1][key].startdate = '';
            value[1][key].enddate = '';
          }

          for (let i = 0; i < value[1][key].operationtime.length; i++) {
            if (i == 0) {
              value[1][key].operationtime[i].dayoftheweek = 'Mon';
            } else if (i == 1) {
              value[1][key].operationtime[i].dayoftheweek = 'Tue';
            } else if (i == 2) {
              value[1][key].operationtime[i].dayoftheweek = 'Wed';
            } else if (i == 3) {
              value[1][key].operationtime[i].dayoftheweek = 'Thu';
            } else if (i == 4) {
              value[1][key].operationtime[i].dayoftheweek = 'Fri';
            } else if (i == 5) {
              value[1][key].operationtime[i].dayoftheweek = 'Sat';
            } else if (i == 6) {
              value[1][key].operationtime[i].dayoftheweek = 'Sun';
            }
            if (
              value[1][key].operationtime[i].endtime != '' &&
              value[1][key].operationtime[i].endtime != undefined
            ) {
              value[1][key].operationtime[i].endtime =
                value[1][key]?.operationtime[i]?.endtime?.format('HH:mm');
            }
            if (
              value[1][key].operationtime[i].starttime != '' &&
              value[1][key].operationtime[i].starttime != undefined
            ) {
              value[1][key].operationtime[i].starttime =
                value[1][key]?.operationtime[i]?.starttime?.format('HH:mm');
            }
          }
        }

        let scheduleData = [];
        let securityData = [];
        for (let k in value[1]) {
          for (let i = 0; i < value[1][k].charge.length; i++) {
            if (value[1][k].charge[i] == undefined) {
              value[1][k].charge.splice(i, 1);
              i--;
            } else {
              if (value[1][k].charge[i].type == undefined) {
                value[1][k].charge[i].type = '';
              }
              if (value[1][k].charge[i].chargefrequency == undefined) {
                value[1][k].charge[i].chargefrequency = '';
              }
              if (value[1][k].charge[i].chargefrequency == undefined) {
                value[1][k].charge[i].chargefrequency = '';
              }
            }
          }
          scheduleData.push(value[1][k]);
        }
        for (let key in value[2]) {
          securityData.push(value[2][key]);
        }

        let bodyData = {
          supplier: session.supplier,
          propertyId: session.propertyId,
          property: {
            recreations: [
              {
                name: value[0].name,
                id: value[0].recreationid,
                type: value[0].type,
                typedetail: value[0].typedetail,
                proximity: value[0].proximity,
                included: value[0].included,
                includedinroomorate:
                  value[0].included == undefined ? '' : value[0].included,
                quanity: value[0].quanity == undefined ? '' : value[0].quanity,
                distance:
                  value[0].distance == undefined ? '' : value[0].distance,
                yearquipreplaced:
                  value[0].yearquipreplaced == undefined
                    ? ''
                    : value[0]?.yearquipreplaced?.format('YYYY'),
                tags: value[0].tags,
                description: value[0].description,
                schedule: scheduleData,
                details: securityData,
              },
            ],
          },
        };
        setAddLoading(true);
        const res = await addRecreation(bodyData);
        if (res.result.success) {
          setAddLoading(false);
          props.cancelAndSave();
        }
      })
      .catch((err) => {
        message.error({
          content: 'Check all the fields please.',
        });
      });
  };
  const [disabledStatus, setDisabledStatus] = useState(true);
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }

    Promise.all([
      AddDetailRef.current.form.validateFields(),
      AddScheduleAndChargeRef.current.form.validateFields(),
      AddAccessibilityAndSecurityRef.current.form.validateFields(),
    ])
      .then(() => {
        setDisabledStatus(false);
      })
      .catch(() => {
        const detailErrNum = AddDetailRef?.current?.form
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const scheduleErrNum = AddScheduleAndChargeRef?.current?.form
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const accessibilityErrNum =
          AddAccessibilityAndSecurityRef?.current?.form
            ?.getFieldsError()
            ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const errTotalNum = detailErrNum + scheduleErrNum + accessibilityErrNum;

        if (errTotalNum === 0) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };

  if (addLoading) return <Loading type="large" />;
  return (
    <Tabs defaultActiveKey="1">
      <TabPane
        tab="Information"
        key="1"
        forceRender={true}
      >
        <PageContainer>
          <Card style={{ marginBottom: '60px' }}>
            <AddPage
              validateFieldsError={validateFieldsError}
              getTransferData={getTransferData}
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddDetailRef}
            />
          </Card>
        </PageContainer>
        <ActionButtonsBar
          onCancel={handlCancelClick}
          onSave={addSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </TabPane>
      <TabPane
        tab="Schedule & Charge"
        key="2"
        forceRender={true}
      >
        <PageContainer>
          <Card>
            <AddScheduleAndCharge
              validateFieldsError={validateFieldsError}
              AddScheduleAndCharge
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddScheduleAndChargeRef}
            />
          </Card>
        </PageContainer>
        <ActionButtonsBar
          onCancel={handlCancelClick}
          onSave={addSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </TabPane>
      <TabPane
        tab="Detail"
        key="3"
        forceRender={true}
      >
        <PageContainer>
          <Card>
            <AddAccessibilityAndSecurity
              validateFieldsError={validateFieldsError}
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddAccessibilityAndSecurityRef}
            />
          </Card>
        </PageContainer>
        <ActionButtonsBar
          onCancel={handlCancelClick}
          onSave={addSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </TabPane>
    </Tabs>
  );
};
export default AddPageTab;
